<template>
  <div class="schedulingList" v-if="auth.list">
    <el-form ref="searchForm" :model="search" size="mini" :inline="true" :label-position="position">
      <el-form-item>
        <el-input v-model="search.id" placeholder="任务id" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="search.isEnabled" @clear="isEnabledClear" clearable placeholder="是否启用">
          <el-option v-for="item in status"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="search.createUserName" placeholder="发布者" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="date" placeholder="发布时间" v-model="search.createTime" format="yyyy-MM-dd"
                        clearable></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searcherSubmit">查询</el-button>
        <el-button type="primary" @click="searcherAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="2">
      <el-col :xs="10">
        <el-table :data="schedulingList" style="width: 100%;" border :fit="true"
                  :header-cell-style="{'text-align':'center'}"
                  :row-class-name="tableRowClassName">
          <el-table-column prop="id" label="任务id" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="memo" label="说明" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="beanName" label="调用类" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="methodName" label="调用方法" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="cron" label="表达式" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="state" label="状态" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state==1? 'success':'info'" disable-transitions>
                {{scope.row.state==1?'启用':'停止'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="发布者" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="createTime" label="发布时间" :formatter="resolvingDate" sortable resizable
                           :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column fixed="right" min-width="150" label="操作" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-button v-show="scope.row.state==1" size="mini" @click="isEnabled(scope.row,scope.$index ,0)"
                         type="info">暂停
              </el-button>
              <el-button v-show="scope.row.state==0" size="mini" @click="isEnabled(scope.row,scope.$index ,1)"
                         type="success">启动
              </el-button>
              <el-button type='primary' size="mini" @click="edit(scope.row,scope.$index )">编辑</el-button>
              <el-button size="mini" @click="getLog(scope.row,scope.$index )">日志</el-button>
              <el-button size="mini" type="danger" @click="remove(scope.row,scope.$index )">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination align='left'
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pages.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="pages.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pages.total">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="任务信息" :visible.sync="dialogFormVisible" center :before-close="handleClose">
      <el-form :model="schedulingInfo" :hide-required-asterisk="false" label-width="auto" size="small"
               :label-position="position" center>
        <el-row>
          <el-col :span="8">
            <el-form-item label="任务id">
              <el-input v-model="schedulingInfo.id" :disabled="disabledInput" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="说明">
              <el-input v-model="schedulingInfo.memo" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item required label="调用类">
              <el-input v-model="schedulingInfo.beanName" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item required label="调用方法">
              <el-input v-model="schedulingInfo.methodName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item required label="表达式">
              <el-input v-model="schedulingInfo.cron" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-switch
                v-model="schedulingInfo.state"
                active-color="#13ce66"
                inactive-color="#909399">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="请求参数(json)">
              <el-input type="textarea" v-model="schedulingInfo.params" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布者">
              <el-input v-model="schedulingInfo.createUserName" :disabled="disabledInput" placeholder="发布者"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布者">
              <el-date-picker type="date" placeholder="发布时间" :disabled="disabledInput"
                              v-model="schedulingInfo.createTime"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateScheduling">确 定</el-button>
        <el-button v-if="schedulingInfo.id" @click="executeSchedule">立即执行</el-button>
      </div>
    </el-dialog>
    <el-dialog title="日志" :visible.sync="dialogLogTableVisible">
      <el-table :data="schedulingLogListData">
        <el-table-column prop="quartzId" label="任务id" sortable resizable :show-overflow-tooltip="true"
                         align="center"/>
        <el-table-column prop="startTime" :formatter="dateFormat" label="开始时间" sortable resizable
                         :show-overflow-tooltip="true"
                         align="center"/>
        <el-table-column prop="endTime" :formatter="dateFormat" label="结束时间" sortable resizable
                         :show-overflow-tooltip="true"
                         align="center"/>
        <el-table-column prop="state"  label="状态" sortable resizable
                         :show-overflow-tooltip="true"
                         align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.state === 1 ? 'primary' : 'danger'"
              disable-transitions>{{scope.row.state==1?"成功":"失败"}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="错误日志" sortable resizable
                         :show-overflow-tooltip="true"
                         align="center">
          <template slot-scope="scope">
            <el-button type="text"  @click="getErrorLog(scope.row)"size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination align='left'
                     @size-change="handleLogSizeChange"
                     @current-change="handleLogCurrentChange"
                     :current-page="logPages.page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="logPages.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="logPages.total">
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
  import {
    getLogQuartz,
    getQuartzInfo,
    getQuartzList,
    quartzAdd,
    quartzIsEnabled,
    quartzRemove,
    updateQuartz,
    quartzExecute
  } from '../../api/api'
  import {getPermission} from '../../api/authRequest'

  export default {
    data() {
      return {
        auth: {
          list: false,
        },
        search: {
          id: '',
          createUserName: '',
          createTime: '',
          isEnabled: null,
        },
        status: [{value: "1", label: "启用"}, {value: "0", label: "未启用"}],
        position: 'left',
        pages: {
          page: 1,
          pageSize: 10,
          total: 0
        },
        logPages:{
          page:1,
          pageSize:10,
          total:0
        },
        schedulingList: [],
        schedulingInfo: {},
        isEnabledParams: {
          id: '',
          isEnabled: null,
        },
        editQuery: {
          id: '',
        },
        dialogFormVisible: false,
        disabledInput: false,
        isAdd: false,
        dialogLogTableVisible: false,
        schedulingLogInfo: {},
        schedulingLogListData: [],
      }
    },
    mounted() {
      this.auth.list = getPermission('/system/scheduling/getQuartzList');
      this.getList();
    },
    methods: {
      //清空是否启用
      isEnabledClear() {
        let _self = this;
        _self.search.isEnabled = null;
      },
      //检索
      searcherSubmit() {
        let _self = this;
        _self.getList();
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.getList()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getList()
      },
      handleLogSizeChange(val){
        this.logPages.pageSize=val;
        this.getSchedulingLog();
      },
      handleLogCurrentChange(Page) {
        this.logPages.page = Page
        this.getSchedulingLog();
      },
      /*时间格式化*/
      resolvingDate: function (row, column) {
        if (!row.createTime) {
          return "";
        }
        let d = new Date(row.createTime);
        let month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
        let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();

        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      },
      dateFormat: function (row, column,cellValue, index) {
        if (!cellValue) {
          return "";
        }else {
          let d = new Date(cellValue);
          let month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
          let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
          let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
          let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
          let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();

          let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
          return times;
        }

      },
      //表格颜色
      tableRowClassName({row, index}) {
        if (row.state == 1) {
          return 'success-row'
        } else {
          return 'warning-row'
        }
      },
      //关闭弹出框
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
      },
      //查询列表
      getList() {
        let _self = this;
        let param = {
          id: _self.search.id,
          createUserName: _self.search.createUserName,
          createTime: _self.search.createTime,
          isEnabled: _self.search.isEnabled,
          pageSize: _self.pages.pageSize,
          startRow: _self.pages.page,
        };
        getQuartzList(param).then(response => {
          if (response.data.status == 100) {
            _self.schedulingList = response.data.results.list;
            _self.pages.total = response.data.results.total;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //是否启用
      isEnabled(row, index, isEnable) {
        let _self = this;
        _self.isEnabledParams.id = row.id;
        _self.isEnabledParams.isEnabled = isEnable;
        _self.enabled();
      },
      enabled() {
        let _self = this;
        if (!_self.isEnabledParams.id) {
          this.$message({
            message: "id is null,修改失败",
            type: "error"
          });
          return;
        }
        if (_self.isEnabledParams.isEnabled == null || _self.isEnabledParams.isEnabled === '' || _self.isEnabledParams.isEnabled === "") {
          this.$message({
            message: "未知是否启用,修改失败",
            type: "error"
          });
          return;
        }
        let params = {
          id: _self.isEnabledParams.id,
          isEnabled: _self.isEnabledParams.isEnabled
        }
        quartzIsEnabled(params).then(response => {
          if (response.data.status == 100) {
            _self.getList();
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //编辑
      edit(row, index) {
        let _self = this;
        _self.editQuery.id = row.id;
        _self.isAdd = false;
        _self.getQuartzInfo();
      },
      //获取详情
      getQuartzInfo() {
        let _self = this;
        if (!_self.editQuery.id) {
          this.$message({
            message: "id is null,修改失败",
            type: "error"
          });
          return;
        }
        let params = {
          id: _self.editQuery.id,
        };
        getQuartzInfo(params).then(response => {
          if (response.data.status == 100) {
            let result = response.data.results;
            _self.schedulingInfo = result;
            _self.schedulingInfo.state = result.state == 1;
            _self.disabledInput = true;
            _self.dialogFormVisible = true;
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //更新
      updateScheduling() {
        let _self = this;
        _self.schedulingInfo.state = _self.schedulingInfo.state == true ? 1 : 0;
        _self.update();
      },
      update() {
        let _self = this;
        let params = {
          id: _self.schedulingInfo.id,
          beanName: _self.schedulingInfo.beanName,
          methodName: _self.schedulingInfo.methodName,
          cron: _self.schedulingInfo.cron,
          isEnabled: _self.schedulingInfo.state,
          params: _self.schedulingInfo.params,
          memo:_self.schedulingInfo.memo,
        };
        if (_self.isAdd) {
          quartzAdd(params).then(response => {
            if (response.data.status == 100) {
              _self.dialogFormVisible = false;
              _self.getList();
            } else {
              this.$message({
                message: response.data.message,
                type: "error"
              });
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          });
        } else {
          updateQuartz(params).then(response => {
            if (response.data.status == 100) {
              _self.dialogFormVisible = false;
              _self.getList();
            } else {
              this.$message({
                message: response.data.message,
                type: "error"
              });
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          });
        }

      },
      //删除
      remove(row, index) {
        let _self = this;
        _self.schedulingInfo.id = row.id;
        _self.removeQuartz();
      },
      removeQuartz() {
        let _self = this;
        let params = {
          id: _self.schedulingInfo.id,
        };
        quartzRemove(params).then(response => {
          if (response.data.status == 100) {
            _self.dialogFormVisible = false;
            _self.getList();
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        });
      },
      //新增
      searcherAdd() {
        let _self = this;
        _self.dialogFormVisible = true;
        _self.disabledInput = true;
        _self.isAdd = true;
        _self.schedulingInfo = {};
      },
      //获取日志
      getLog(row, index) {
        let _self = this;
        _self.schedulingLogInfo.id = row.id;
        _self.getSchedulingLog();
      },
      getSchedulingLog() {
        let _self = this;
        let params = {
          id: _self.schedulingLogInfo.id,
          pageSize: _self.logPages.pageSize,
          startRow: _self.logPages.page,
        };
        getLogQuartz(params).then(response => {
          if (response.data.status == 100) {
            _self.dialogLogTableVisible = true;
            _self.schedulingLogListData = response.data.results.list;
            _self.logPages.total = response.data.results.total;
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        });
      },
      //获取错误日志
      getErrorLog(row){
        this.$msgbox({
          title:'异常信息',
          message:row.error,
          dangerouslyUseHTMLString: false,
          showConfirmButton: false,
          customClass:"mod-sys__log-error-view-info",
        }).catch((error) => {
        })
      },
      executeSchedule() {
          let _self = this;
        // _self.schedulingInfo.state = _self.schedulingInfo.state == true ? 1 : 0;
        quartzExecute({ id: _self.schedulingInfo.id }).then(response => {
          if (response.data.status == 100) {
          this.$message({
              message: "执行成功",
              type: "success"
            });
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        });
      }
    },
  }
</script>
<style lang="scss" scoped>
  .schedulingList {
    .box-card {
      margin-bottom: 20px;
      border-radius: 0px;

      .card-header {
        font-size: 14px;
        line-height: 0px;
      }
    }
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>



// WEBPACK FOOTER //
// schedulingList.vue?de64cfbe